import optionsContacts  from '../config/optionsContacts';
import  markerFragment from '../config/marker';

window.addEventListener('load', () => {

   (function () {

       const mapPanel = $(".map-contacts-panel");
       const mapAddress = mapPanel.data("address").toString();

       const lat = parseFloat(mapPanel.data("lat"));
       const lng = parseFloat(mapPanel.data("long"));

       function initMap() {
           const property = {lat: +lat, lng: +lng};
           let _mapOptions = optionsContacts;
           const map = new google.maps.Map(document.getElementById('mapContacts'), _mapOptions);
           let _infoWindow = new google.maps.InfoWindow({ content: mapAddress });

           /*** Overrides Map Center ***/
           let center = new google.maps.LatLng(lat,lng);
           map.panTo(center);

           const icon  = markerFragment;
           const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

           const marker = new google.maps.Marker({
               title: 'Офис',
               position: property,
               map: map,
               icon: {
                   url: (isIE11 ? "http://maps.google.com/mapfiles/ms/icons/red-dot.png" : 'data:image/svg+xml, ' + encodeURI(icon)),
                   scaledSize: (isIE11 ? new google.maps.Size(27, 27) : new google.maps.Size(21, 21))
               }
           });

           marker.addListener('click', function() {
               _infoWindow.open(map, marker);
           });
           /*** Open Info Window - Default ***/
           _infoWindow.open(map, marker);
       }
       initMap();
    })();
});